export default {
  SET_DRAGGED_ITEM(state, payload) {
    state.draggedItem = payload;
  },
  SET_USUARIOS_RESPONSAVEIS(state, payload) {
    state.listaResponsaveis = payload;
  },
  SET_CARDS(state, payload) {
    state.cards = payload;
  },
  SET_CARD(state, payload) {
    state.cardSelecionado = payload;
  },
  SET_PRIORIDADE_CARD(state, payload) {
    state.cardSelecionado.informacoesGerais.prioridade = payload;
  },
  SET_RESPONSAVEL_CARD(state, payload) {
    state.cardSelecionado.responsavel.ANALISTA = payload;
  },
  SET_ASSISTENTE1_CARD(state, payload) {
    state.cardSelecionado.responsavel.ASSISTENTE1 = payload;
  },
  SET_HAS_INTERVAL(state, payload) {
    state.hasInterval = payload;
  },
  SET_USUARIOS_RESPONSAVEIS_TRUST(state, payload) {
    state.responsaveisTrust = payload.map(({ id, nome, foto, email }) => ({
      id, nome, foto, Email: email,
    }));
  },
  SET_USUARIOS_RESPONSAVEIS_COMEX(state, payload) {
    state.responsaveisComex = payload.map(({ id, nome, foto, email, cargo, cargoSlug }) => ({
      id, nome, foto, Email: email, cargo, cargoSlug,
    }));
  },
  SET_ATIVIDADES_CARD(state, payload) {
    const { etapa, atividade, value } = payload;
    state.cardSelecionado.checklist[etapa][atividade] = value;
  },
  SET_OBSERVACAO(state, payload) {
    state.cardSelecionado.observacoes.push(payload);
  },
  ADD_HISTORICO_CARD(state, payload) {
    state.cardSelecionado.historico.push(payload);
  },
  ADD_HISTORICO_COMPLETO_CARD(state, payload) {
    state.cardSelecionado.historicoCompleto.push(payload);
  },
  ADD_HISTORICO_CARD_DRAGGED_ITEM(state, payload) {
    state.draggedItem.historico.push(payload);
  },
  SET_TAREFA_CARD_SELECIONADO(state, payload) {
    state.cardSelecionado.checklist[payload.etapa][payload.indexAtividade].value = payload.value;
  },
  UPDATE_TAREFA_ADMINISTRATIVO_EMITIRLI(state, payload) {
    if (payload.atividade === 'semLi' && payload.value === true) {
      if (state.cardSelecionado.checklist.administrativo[payload.indexEmitirLi].options[0].value) {
        state.cardSelecionado.checklist.administrativo[payload.indexEmitirLi].options[0].value = false;
      }
      if (state.cardSelecionado.checklist.administrativo[payload.indexEmitirLi].options[1].value) {
        state.cardSelecionado.checklist.administrativo[payload.indexEmitirLi].options[1].value = false;
      }
      state.cardSelecionado.checklist.administrativo[payload.indexEmitirLi].options[2].value = payload.value; // semLi
    }
    if (payload.atividade === 'liPos' || payload.atividade === 'liPre') {
      if (state.cardSelecionado.checklist.administrativo[payload.indexEmitirLi].options[2].value && payload.value === true) {
        state.cardSelecionado.checklist.administrativo[payload.indexEmitirLi].options[2].value = false;
      }
      state.cardSelecionado.checklist.administrativo[payload.indexEmitirLi].options[payload.indexAtividade].value = payload.value;
    }
  },
  UPDATE_TAREFA_NACIONALIZACAO_CHECKLIST_NOTA_REALIZADO(state, payload) {
    if (payload.atividade === 'checklistNotaRealizado' && payload.value === false) {
      // Atividade Solicitado NF e Recebimento NF devem ficar falsos
      if (state.cardSelecionado.checklist.nacionalizacao[payload.indexAtividade + 1].value) {
        state.cardSelecionado.checklist.nacionalizacao[payload.indexAtividade + 1].value = false;
      }
      if (state.cardSelecionado.checklist.nacionalizacao[payload.indexAtividade + 2].value) {
        state.cardSelecionado.checklist.nacionalizacao[payload.indexAtividade + 2].value = false;
      }
      state.cardSelecionado.checklist.nacionalizacao[payload.indexAtividade].value = false;
    }

    if (payload.atividade === 'solicitadoNF' && payload.value === false) {
      // Atividade recebimento deve receber false também caso
      if (state.cardSelecionado.checklist.nacionalizacao[payload.indexAtividade + 1].value) {
        state.cardSelecionado.checklist.nacionalizacao[payload.indexAtividade + 1].value = false;
      }
      state.cardSelecionado.checklist.nacionalizacao[payload.indexAtividade].value = false;
    }
    state.cardSelecionado.checklist.nacionalizacao[payload.indexAtividade].value = payload.value;
  },
  UPDATE_TAREFA_ACOMPANHAMENTO_DTC_DTA(state, payload) {
    // Se solicitacaoRemocaoDTC for marcada como SIM automaticamente a solicitacaoRemocao DTA deve ser marcada como NÃO
    const { atividade, value, indexAtividade } = payload;

    const toggleValue = (index, newValue) => {
      state.cardSelecionado.checklist.acompanhamento[index].value = newValue;
    };

    if (atividade === 'solicitacaoRemocaoDTC') {
      toggleValue(indexAtividade + 1, !value);
      toggleValue(indexAtividade, value);
    }

    if (atividade === 'solicitacaoRemocaoDTA') {
      toggleValue(indexAtividade - 1, !value);
      toggleValue(indexAtividade, value);
    }
  },
  REMOVE_ALERTA_CARD_SELECIONADO(state, index) {
    state.cardSelecionado.alertas.splice(index, 1);
  },
  ADD_ALERTA_CARD_SELECIONADO(state, alerta) {
    const existAlerta = state.cardSelecionado.alertas.findIndex((item) => item === alerta);
    if (existAlerta === -1) {
      state.cardSelecionado.alertas.push(alerta);
    }
  },
  SET_MOSTRAR_CONCLUIDOS(state, payload) {
    state.mostrarConcluidos = payload;
  },
};
